import React, { useState, useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import api from '../../../services/api';

const WhyChooseUsPreview = ({ isAdminPreview = true }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const res = await api.get('/business/why-choose-us/');
      setItems(res.data || []);
    } catch (err) {
      console.error('Error fetching why choose us:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (isAdminPreview) {
      const interval = setInterval(fetchData, 2000);
      return () => clearInterval(interval);
    }
  }, [isAdminPreview]);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!items.length) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.5)',
        backgroundColor: '#1e293b',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        No benefits added yet.
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem', backgroundColor: '#1e293b', minHeight: '200px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#fff', textAlign: 'center', marginBottom: '1.5rem' }}>
        Why Choose Us
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '1rem'
      }}>
        {items.slice(0, 6).map((item, index) => (
          <div
            key={item.id || index}
            style={{
              padding: '1rem',
              backgroundColor: 'rgba(255,255,255,0.05)',
              borderRadius: '0.75rem',
              textAlign: 'center'
            }}
          >
            <div style={{
              width: '2.5rem',
              height: '2.5rem',
              borderRadius: '50%',
              backgroundColor: 'rgba(99, 102, 241, 0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 0.75rem'
            }}>
              {item.icon ? (
                <span style={{ fontSize: '1.25rem' }}>{item.icon}</span>
              ) : (
                <CheckCircle size={20} style={{ color: '#6366f1' }} />
              )}
            </div>
            <h3 style={{ color: '#fff', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.25rem' }}>
              {item.title}
            </h3>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.75rem', lineHeight: '1.4' }}>
              {item.description?.substring(0, 60)}...
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseUsPreview;
